import { Component, OnInit, ViewChild } from '@angular/core';
import { FeedbackErrorService } from '../service/feedback-error.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { DataTable } from 'primeng/primeng';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectItem } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-feedback-error-file',
  templateUrl: './feedback-error-file.component.html',
  styleUrls: ['./feedback-error-file.component.css']
})
export class FeedbackErrorFileComponent implements OnInit {

  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  //listfileName: any[] = [];
  listCustomerAccountManager: any[] = [];
  selectedCustomerAccountManager: any = null;
  listMisparMezaheOved: any[] = [];
  selectedMisparMezaheOved: string = null;
  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];
  selectedCheckBox: any[];
  display: boolean = false;
  btnDialog: boolean = false;
  cloneArray: any = { FeedbackId: null, FileDepositId: null, Note: '', OriginalFileName: null, FeedbackStatudUpdateDate: null, Urgent: false };
  flag: boolean;
  selectedMsgSent: boolean = true; // false;
  userDetails: any = null;
  @ViewChild('dt') dataTable: DataTable = null;
  tabActiveIndex: any = 0;
  //feedbackStatisesPrecalculated: any[] = null;
  columns: SelectItem[];
  selectedColumns: any[];
  rowGroupMetadata: any;
  rowsLimit: number = 1000;
  rowsTobeUpdated: any = null;
  downloadFileGuid: any = null;
  showDownloadFileGuid: any = false;
  showFeedbackErrorCodeDescription: any = false;
  FeedbackError: any = null;

  constructor(private dataService: FeedbackErrorService, private router: Router, private userService: UserService) {

    this.columns = [
      { label: 'זיהוי מעסיק', value: 'IdentityNumber' },
      { label: 'שם מעסיק', value: 'CustomerName' },
      { label: 'שם קובץ', value: 'OriginalFileName' },
      { label: 'חודש דיווח', value: 'ReportMonth' },
      { label: 'תאריך דיווח', value: 'ReportDateFormatted' },
      { label: 'קוד שגיאה', value: 'FeedbackErrorCodeId' },
      { label: 'הטיפול המתבקש', value: 'MailContent' }
    ];

    this.selectedColumns = ['IdentityNumber', 'CustomerName', 'OriginalFileName',
                            'ReportMonth', 'FeedbackErrorCodeId', 'MailContent'];

  }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;

      this.dataService.getCustomerAccountManagerDDL('').subscribe((result: any) => {
        this.listCustomerAccountManager = result;
        this.listCustomerAccountManager.unshift({ label: 'הכל', value: null });
        let filteredElements = this.listCustomerAccountManager.filter(element => element.value == this.userDetails.Email)
        if (filteredElements.length > 0) {
          this.selectedCustomerAccountManager = this.userDetails.Email;
        }
        this.getCus();
      },
        (err: HttpErrorResponse) => {
          // this.router.navigate(['error-page/', err.error.ExceptionMessage])
          this.showMessage('error', '', 'תקלה בקבלת רשימת מנהל תיק');
        });

    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
      });

    

    // this.dataService.getFeedbackStatisesPrecalculated().subscribe((result: any) => {
    //   this.feedbackStatisesPrecalculated = result;
    // },
    //   (err: HttpErrorResponse) => {
    //     //this.router.navigate(['error-page/', err.error.ExceptionMessage])
    //     this.showMessage('error', '', 'תקלה בקבלת נתונים מחושבים מראש');
    //   });

    this.cols = [
      { field: 'MailContent', header: 'הטיפול המתבקש' },
      { field: 'FeedbackErrorCodeId', header: 'קוד שגיאה' },
      { field: 'ReportDateFormatted', header: 'תאריך דיווח' },
      { field: 'ReportMonth', header: 'חודש דיווח' },
      { field: 'OriginalFileName', header: 'שם קובץ' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'IdentityNumber', header: 'זיהוי מעסיק' }
    ];

  }

  isColumnToShow(columnsName: string): any {
    if (this.selectedColumns.indexOf(columnsName) == -1) return 'none'; else return 'table-cell';
  }

  getFeedbackErrorFile(): void {
    this.resultTable = null;
    this.btnDialog = false;
    this.selectedCustomerId = this.selectedCustomerId === null ? '' : this.selectedCustomerId;
    this.selectedCustomerAccountManager = this.selectedCustomerAccountManager === null ? '' : this.selectedCustomerAccountManager;
    this.selectedMsgSent = this.selectedMsgSent === true ? true : false;
    this.dataService.getFeedbackErrorFile(this.selectedCustomerId, this.selectedCustomerAccountManager, this.selectedMsgSent, this.rowsLimit).subscribe((result: any) => {
      this.resultTable = result;
      this.updateRowGroupMetaData();
      if (this.resultTable.length.toString() === this.rowsLimit.toString()) {
        let msg = 'סינון שנבחר הינו רחב מדי, מוצגות ' +
          this.rowsLimit.toString() +
          ' תוצאות ראשונות בלבד. נא לעדן את הסינון';
        this.showMessage('warn', '', msg);
        // this.showMessage('warn', '', 'סינון שנבחר הינו רחב מדי, מוצגות 1000 תוצאות ראשונות בלבד. נא לעדן את הסינון');
      }
      if (this.resultTable.length > 0) {
        let cnt = this.getCnt();
        if (cnt > 0) {
          this.flag = true;
          this.setCheckboxValuesInArray(this.flag);
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בהצגת הדוח');
      });
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.resultTable) {
      for (let i = 0; i < this.resultTable.length; i++) {
        let rowData = this.resultTable[i];
        let customer = rowData.IdentityNumberWithCustomerName;
        if (i == 0) {
          this.rowGroupMetadata[customer] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.resultTable[i - 1];
          let previousRowGroup = previousRowData.IdentityNumberWithCustomerName;
          if (customer === previousRowGroup)
            this.rowGroupMetadata[customer].size++;
          else
            this.rowGroupMetadata[customer] = { index: i, size: 1 };
        }
      }
    }
  }

  sendMails(): void {
    this.dataService.sendMails(this.resultTable).subscribe((result: any) => {
      this.showMessage('success', '', 'שליחת המיילים תוזמנה בהצלחה');
      this.getFeedbackErrorFile();
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בתזמון שליחת המיילים ');
      });
  }

  setChecked(event: boolean, feedbackId: number): void {
    if (event) {
      let i = this.resultTable.findIndex(i => i.FeedbackId === feedbackId);
      if (i != -1) {
        this.resultTable[i].Check = true
      }
    }
    else {
      let i = this.resultTable.findIndex(i => i.FeedbackId === feedbackId);
      if (i != -1)
        this.resultTable[i].Check = false
    }
    this.setBtnDialog();
  }

  setBtnDialog(): void {
    let i = this.resultTable.findIndex(i => i.Check === true);
    let cnt = this.resultTable.filter(i => i.Check === true).length;
    if (i != -1 && cnt >= 2) {
      this.btnDialog = true;
    }
    else {
      this.btnDialog = false;
    }
  }

  //setUpdate(FeedbackId: number, FileDepositId: number, Check: boolean, MISPAR_MEZAHE_RESHUMA: string, OriginalFileName: string, FeedbackStatudUpdateDate: string, Urgent: boolean): any {
  //  if ((FeedbackId === null || FeedbackId === undefined) || (!Check) || (MISPAR_MEZAHE_RESHUMA === null || MISPAR_MEZAHE_RESHUMA === undefined || MISPAR_MEZAHE_RESHUMA === "")) {
  //    return this.showMessage('error', '', 'שגיאה. תקלה לא צפויה');
  //  }

  //  this.cloneArray.FeedbackId = FeedbackId;
  //  this.cloneArray.FileDepositId = FileDepositId;
  //  this.cloneArray.MISPAR_MEZAHE_RESHUMA = MISPAR_MEZAHE_RESHUMA;
  //  this.cloneArray.OriginalFileName = OriginalFileName;
  //  this.cloneArray.FeedbackStatudUpdateDate = FeedbackStatudUpdateDate;
  //  this.cloneArray.Urgent = Urgent;
  //  this.display = true;
  //}

  //showArray(): void {

  //  this.rowsTobeUpdated = 0;
  //  this.resultTable.forEach(element => {
  //    if (element.Check === true && (element.FeedbackId !== null || element.FeedbackId !== undefined)) {
  //      this.rowsTobeUpdated += 1;
  //    }
  //  });
  //  this.cloneArray = {};
  //  this.display = true;


  //}

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  getCnt(): number {
    let cnt = this.resultTable.filter(i => (i.FeedbackId !== null || i.FeedbackId !== undefined) && (i.MISPAR_MEZAHE_RESHUMA !== null || i.MISPAR_MEZAHE_RESHUMA !== "")).length;
    return cnt;
  }

  setCheckboxValuesInArray(event: boolean): void {
    if (event) {
      let filteredValueCnt: number = -1;
      // try {
      //   filteredValueCnt = this.dataTable.filteredValue.length;
      // } catch (error) {
      //   filteredValueCnt = -1;
      // }
      try {
        if (this.dataTable) {
          if (this.dataTable.filteredValue) {
            filteredValueCnt = this.dataTable.filteredValue.length;
          }
          else {
            filteredValueCnt = -1;
          }
        }
        else {
          filteredValueCnt = -1;
        }
      } catch (error) {
        filteredValueCnt = -1;
      }

      if (filteredValueCnt === -1) {
        for (let i = 0; i < this.resultTable.length; i++) {
          let element = this.resultTable[i];
          if ((element.FeedbackId)) {
            this.setChecked(true, element.FeedbackId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt > 0) {
        for (let i = 0; i < this.dataTable.filteredValue.length; i++) {
          let element = this.dataTable.filteredValue[i];
          if ((element.FeedbackId)) {
            this.setChecked(true, element.FeedbackId);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt === 0) {
        this.flag = false;
        this.showMessage('info', '', 'לא נמצאו נתונים עבור הסינון שנבחר');
      }
    }
    else {
      for (let i = 0; i < this.resultTable.length; i++) {
        let element = this.resultTable[i];
        if ((element.FeedbackId)) {
          this.setChecked(false, element.FeedbackId);
          this.flag = false;
        }
      }
    }
  }

  onFilter(): void {
    this.setCheckboxValuesInArray(false);
    this.setCheckboxValuesInArray(true);
  }

  onSort() {
    this.updateRowGroupMetaData();
  }

  getFeedbackReport(): void {
    if (!confirm("הפקת דוח צפויה להימשך זמן רב, האם להמשיך?")) { return; }
    this.dataService.getFeedbackReport().subscribe((result: any) => {
      this.showMessage('success', '', 'הדוח תוזמן ובסיום הפקה יישלח מייל למנהל המערכת');
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בתזמון הפקת דוח ');
      });
  }

  getFeedbackErrorCodeDescription(code): void {
    try {
      if (code == null || code == '') { return; }
      this.FeedbackError = null;
      this.dataService.getFeedbackErrorCodeDescription(code).subscribe((result: any) => {
        this.FeedbackError = result;
        this.showFeedbackErrorCodeDescription = true;
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת תאור קוד שגיאה');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה לא צפויה בקבלת תאור קוד שגיאה');
    }
  }

  FeedbackErrorCodeDescriptionClosed(): void {
    this.FeedbackError = null;
  }

  getCus() {
    //if (this.selectedCustomerAccountManager != null || this.selectedCustomerAccountManager != undefined) {
    this.selectedCustomerAccountManager = this.selectedCustomerAccountManager === null ? '' : this.selectedCustomerAccountManager;
    this.dataService.getCustomer(this.selectedCustomerAccountManager).subscribe((result: any) => {
      this.listcustomer = result;
      this.listcustomer.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
      });
    //} else {
    //  this.showMessage('error', '', 'חייב להזין מנהל תיק');
    //}
  }


  //----------------------------------------------
  BlockSendToCustomerBlock(identityNumber) {
    if (confirm('האם ברצונך לחסום הפצת מיילים למעסיק?')) {
      this.dataService.BlockSendToCustomer(identityNumber, true).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToCustomer = true;
            this.resultTable[i].SendToCustomer = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים למעסיק נחסמה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת מעסיק נוקו למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בחסימת הצפת מיילים למעסיק ');
        });
    }
  }

  BlockSendToCustomerAllow(identityNumber) {
    if (confirm('האם ברצונך לאפשר הפצת מיילים למעסיק?')) {
      this.dataService.BlockSendToCustomer(identityNumber, false).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToCustomer = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים למעסיק אופשרה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת מעסיק נשארו ריקים למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בנסיון לאפשר הצפת מיילים למעסיק ');
        });
    }
  }

  //----------------------------------------------
  BlockSendToAccountantBlock(identityNumber) {
    if (confirm('האם ברצונך לחסום הפצת מיילים לרואה חשבון עבור מעסיק זה?')) {
      this.dataService.BlockSendToAccountant(identityNumber, true).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToAccountant = true;
            this.resultTable[i].SendToAccountant = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים לרואה חשבון עבור המעסיק נחסמה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת רואה חשבון נוקו למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בחסימת הצפת מיילים לרואה חשבון עבור המעסיק ');
        });
    }
  }

  BlockSendToAccountantAllow(identityNumber) {
    if (confirm('האם ברצונך לאפשר הפצת מיילים לרואה חשבון עבור מעסיק זה?')) {
      this.dataService.BlockSendToAccountant(identityNumber, false).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToAccountant = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים לרואה חשבון עבור המעסיק אופשרה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת רואה חשבון נשארו ריקים למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בנסיון לאפשר הצפת מיילים לרואה חשבון עבור המעסיק ');
        });
    }
  }

  //----------------------------------------------
  BlockSendToAgentBlock(identityNumber) {
    if (confirm('האם ברצונך לחסום הפצת מיילים לסוכן עבור מעסיק זה?')) {
      this.dataService.BlockSendToAgent(identityNumber, true).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToAgent = true;
            this.resultTable[i].SendToAgent = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים לסוכן עבור המעסיק נחסמה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת סוכן נוקו למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בחסימת הצפת מיילים לסוכן עבור המעסיק ');
        });
    }
  }

  BlockSendToAgentAllow(identityNumber) {
    if (confirm('האם ברצונך לאפשר הפצת מיילים לסוכן עבור מעסיק זה?')) {
      this.dataService.BlockSendToAgent(identityNumber, false).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToAgent = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים לסוכן עבור המעסיק אופשרה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת סוכן נשארו ריקים למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בנסיון לאפשר הצפת מיילים לסוכן עבור המעסיק ');
        });
    }
  }

  //----------------------------------------------
  BlockSendToFundInstitutionBlock(identityNumber) {
    if (confirm('האם ברצונך לחסום הפצת מיילים למוסדי עבור מעסיק זה?')) {
      this.dataService.BlockSendToFundInstitution(identityNumber, true).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToFundInstitution = true;
            this.resultTable[i].SendToFundInstitution = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים למוסדי עבור המעסיק נחסמה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת מוסדי נוקו למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בחסימת הצפת מיילים למוסדי עבור המעסיק ');
        });
    }
  }

  BlockSendToFundInstitutionAllow(identityNumber) {
    if (confirm('האם ברצונך לאפשר הפצת מיילים למוסדי עבור מעסיק זה?')) {
      this.dataService.BlockSendToFundInstitution(identityNumber, false).subscribe((result: any) => {
        for( var i = 0; i < this.resultTable.length; i++) {
          if (this.resultTable[i].IdentityNumber == identityNumber) {
            this.resultTable[i].BlockSendToFundInstitution = false;
          }
        }
        this.showMessage('success', '', 'אפשרות הפצת מיילים למוסדי עבור המעסיק אופשרה');
        //this.showMessage('info', '', 'שים לב, סימונים עבור עמודת מוסדי נשארו ריקים למעסיק זה');
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בנסיון לאפשר הצפת מיילים למוסדי עבור המעסיק ');
        });
    }
  }
  //----------------------------------------------
  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-error-file/feedback-error-file.component.ts